import {match} from 'path-to-regexp'

import {parseQueryString} from '@s-ui/js/lib/string/index.js'

export const cleanExtraQuotes = str => {
  if (!str) return ''

  return str.replace(/[\\"]/g, '')
}

export const getUuidV4 = () => {
  // to be replaced by Node's own implementation, available 16.7 upwards
  // https://developer.mozilla.org/en-US/docs/Web/API/Crypto/randomUUID
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, character => {
    const random = (Math.random() * 16) | 0
    const value = character === 'x' ? random : (random & 0x3) | 0x8
    return value.toString(16)
  })

  return uuid
}

export const getForcedValue = ({key, queryString}) => {
  if (!queryString) return
  const queryParams = parseQueryString(queryString)
  return queryParams[`suipde_${key}`]
}

export const isMatchingRoute = ({pathName, route}) => {
  if (typeof route === 'string') {
    const matchRoute = match(route, {decode: decodeURIComponent})
    return !!matchRoute(pathName)
  }

  if (route instanceof RegExp) {
    return route.test(pathName)
  }

  return false
}

const isExactRoute = (pathname, route) => pathname === route || pathname === `${route}/`

export const isLayoutMatchingRoute = ({route, router}) => {
  return typeof route === 'object'
    ? router.location.pathname.match(route)
    : isExactRoute(router.location.pathname, route)
}

export const stripSlash = p => p?.replace(/\/$/, '')

export const getHasPromiseError = ({controlledError, status}) => {
  const hasControlledError = Boolean(controlledError)
  const hasPromiseRejectedstatus = status === 'rejected'
  return hasControlledError || hasPromiseRejectedstatus
}

export const logServerError = ({from, error = 'unknown'}) => {
  // eslint-disable-next-line no-console
  console.error(`${from} error: ${error}`)
}

export const serverErrorsHandler = ({errors}) => {
  const criticalServerErrors = errors.map(({controlledError, from, isCritical, status}) => {
    const hasPromiseError = getHasPromiseError({controlledError, status})
    if (!hasPromiseError) return null
    logServerError({error: controlledError, from})
    return isCritical && from
  })

  return {hasCriticalServerError: Boolean(criticalServerErrors.filter(Boolean).length)}
}
